let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jlDVs")).then(() => parcelRequire('Le10t'));